export default function ConditionalRenderer({ children, show = false }) {
  return show ? <>{children}</> : <></>;
}
